// extracted by mini-css-extract-plugin
export default {"cls1":"FocusedNav-cls1_Pa9","cls2":"FocusedNav-cls2_z1G FocusedNav-cls1_Pa9"};